import { createApiRef } from '@backstage/core-plugin-api';
import { Releases } from '.';

export const githubApiRef = createApiRef<GithubApi>({
  id: 'plugin.githubapi.service',
});

export type GithubApi = {
  listReleases: (options: {
    hostname?: string;
    owner: string;
    repo: string;
    pageSize?: number;
    page?: number;
  }) => Promise<Releases>;
};
